window.axios = require("axios");

import BlogListing from "./pages/BlogListing";
import BlogSingle from "./pages/BlogSingle";
import ChronoFaq from "./pages/ChronoFaq";
import ChronoHelp from "./pages/ChronoHelp";
import ChronoContact from "./pages/ChronoContact";
import HelpSingle from "./pages/HelpSingle";
import LundiBixi from "./pages/LundiBixi";
import Landing from "./pages/Landing";

/**
 * Main entry point of the website.
 *
 * @copyright Swoo Inc
 * @website http://swoo.ca
 */
class Main {
  /**
   * Constructor of the class.
   *
   * @return void
   */
  constructor() {
    console.log("Main :: init");

    document.addEventListener("DOMContentLoaded", this.init);
  }

  init() {
    if (document.querySelector("#blog-listing")) {
      new BlogListing();
    } else if (document.querySelector(".main.faq")) {
      new ChronoFaq();
    } else if (document.querySelector("#blog-single")) {
      new BlogSingle();
    } else if (document.querySelector("#lundi-bixi")) {
      new LundiBixi();
    } else if (document.querySelector("#landing-page")) {
      new Landing();
    } else if (document.querySelector("#help-listing")) {
      new ChronoHelp();
    } else if (document.querySelector("#help-single")) {
      new HelpSingle();
    }
    else if (document.querySelector("#chrono-contact")) {
      new ChronoContact();
    }
  }
}

new Main();
